export const logo = require("../../images/logo.png");
export const digital_wallet_icon = [
  require("../../images/bitcoin.svg"),
  require("../../images/etherum.svg"),
  require("../../images/tether.svg"),
  require("../../images/doge.svg"),
]
export const define_img = [
  require("../../images/exchange.jpg")
]